/** Remove legacy OIDC debug material from browser storage (security scan remediation). */
export function clearOidcDebugStorage(): void {
  try {
    localStorage.removeItem('provysn-okta-tokens');
    sessionStorage.removeItem('provysn-okta-auth-code');
    sessionStorage.removeItem('provysn-okta-auth-state');
    sessionStorage.removeItem('provysn-okta-exchanged-code');
  } catch {
    /* ignore */
  }
}
